module.exports = __webpack_public_path__ + "img/icon-loader-brasilcard1.cb762e18.svg";